/**
 * @file 接口加密 与客户端逻辑一致 带有param加密
 *
 * 统一使用commonjs规范，适配nodejs端使用。
 */
import md5 from 'blueimp-md5';
/**
 * 创建指定位数随机数
 */
function createUuid(len) {
    let v = Math.random().toString().slice(-len);
    // 避免首位为0
    if (v[0] === '0') {
        v = '1' + v.slice(1);
    }
    return +v;
}
/**
 * 对象转为 &key=value格式
 */
export function objectToStr(params) {
    const keys = Object.keys(params).sort();
    let secretStr = '';
    keys.forEach((item, index) => {
        if (index === 0) {
            secretStr += `${item}=${params[item]}`;
        }
        else {
            secretStr += `&${item}=${params[item]}`;
        }
    });
    return secretStr;
}
export default function crypto(s, params = {}, isString = false) {
    const accessSecret = s;
    const timestamp = +new Date();
    const nonce = createUuid(12);
    const secretParam = { ...params, timestamp, nonce };
    let secretStr = objectToStr(secretParam);
    // 排序后，加上秘钥
    secretStr += '&accessSecret=' + accessSecret;
    const sign = md5(String(secretStr)).toUpperCase();
    if (isString) {
        return `timestamp=${timestamp}&nonce=${nonce}&sign=${sign}`;
    }
    return {
        timestamp,
        nonce,
        sign,
    };
}
